import $ from "jquery";
import slick from "slick-carousel";

function initCarousels() {

  if (
    $(".js-testimonials-slider").length &&
    !$(".js-testimonials-slider").hasClass("slick-initialized")
  ) {
    $(".js-testimonials-slider").slick({
        mobileFirst: true,
        infinite: false,
        autoplay: true,
        speed: 500,
        autoplaySpeed: 5000,
        cssEase: "ease-in-out",
        adaptiveHeight: false,
        draggable: true,
        swipe: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
    });   
  }
}

$(document).ready(function () {
  initCarousels();
});

(function () {
  if (typeof wp === "undefined") {
    return;
  }

  if (typeof wp?.data !== "undefined") {
    wp?.data.subscribe(() => {
      initCarousels();
    });
  }
})();